module.exports = __webpack_public_path__ + "static/img/cocina_13.9f171e4b.png";